// Tøm handlekurven når vi lander på /order-confirmation/:id
// (men ALDRI ved avbrudd eller feil).
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useCart } from "./CartContext";

function getOrderId(pathname) {
  const m = pathname.match(/^\/order-confirmation\/(\d+)/);
  return m ? m[1] : null;
}

export function ClearCartOnFlag() {
  const { clearCart } = useCart();
  const location = useLocation();

  useEffect(() => {
    const orderId = getOrderId(location.pathname);

    // 1) Backward-compat: støtt evt. gammel flagg hvis det fortsatt finnes.
    if (sessionStorage.getItem("clearCartOnNextLoad") === "1") {
      clearCart();
      sessionStorage.removeItem("clearCartOnNextLoad");
      // Merk at vi ikke returnerer her; vi kan også treffe order-confirmation under samme last.
    }

    // 2) Ny, deterministisk regel: tøm ved vellykket landing på orderbekreftelse.
    if (orderId) {
      const key = `cartClearedForOrder:${orderId}`;
      if (!sessionStorage.getItem(key)) {
        clearCart();
        sessionStorage.setItem(key, "1");
      }
    }
  }, [location.pathname, clearCart]);

  return null;
}
